import CurrentUserStore from "@shared/svelte/Stores/CurrentUserStore";
import * as stagedRollouts from "@shared/services/staged_rollouts";

const userNameStringUtil = function (user) {
  if (!user) {
    return "";
  }
  var str = "";
  if (user.first_name) {
    str += user.first_name;
  }
  if (user.last_name) {
    if (str.trim().length > 0) str += " ";
    str += user.last_name;
  }

  if (str.trim().length < 1) return (user.email || "").trim();
  return str.trim();
};

var service = function ($rootScope, $http, CachedRequest, $q, C) {
  $rootScope.trueUser = {};

  // Takes a User object, and outputs a string representing their full name.
  // If the user has no first or last name, a default string is returned.
  var userNameString = function (user) {
    return userNameStringUtil(user);
  };

  var loadOnboarding = function () {
    var defer = $q.defer();
    $http({
      method: "GET",
      url: C.userUrl,
    }).then(function success(res) {
      stagedRollouts.prepareStagedRollouts(res.data.staged_rollouts);
      $rootScope.user = res.data;
      CurrentUserStore.update(n => $rootScope.user);
      window.sentryContext.user = _.pick($rootScope.user, ["id", "email", "role"]);
      defer.resolve(res.data);
      if (_.get($rootScope.user, "user_return_to") && $rootScope.user.user_return_to != "/") {
        sessionStorage.setItem("signupReturnTo", $rootScope.user.user_return_to);
      }
    });
    return defer.promise;
  };

  var cachedLoadRes;
  var load = function (callback) {
    if (!cachedLoadRes) {
      cachedLoadRes = CachedRequest({
        method: "GET",
        url: C.userUrl,
      });

      cachedLoadRes.then(function success(res) {
        CurrentUserStore.update(n => res.data);
        $rootScope.user = res.data;
        stagedRollouts.prepareStagedRollouts(res.data?.staged_rollouts?.staged_rollouts);
        window.sentryContext.user = _.pick($rootScope.user, ["id", "email", "role"]);
        if (callback) callback(res.data);
      });
    }

    return cachedLoadRes;
  };

  var trueUser = function (callback) {
    return CachedRequest({
      method: "GET",
      url: C.userUrl,
      params: {
        true_user: true,
      },
    }).then(
      function success(res) {
        $rootScope.trueUser = res.data;
        window.sentryContext.trueUser = _.pick($rootScope.trueUser, ["id", "email", "role"]);
        if (callback) callback(res.data);
      },
      function error(res, status, headers, config, statusText) {
        console.log("true user error: " + JSON.stringify(res));
        console.log("status: " + status);
        console.log("statusText: " + statusText);
      },
    );
  };

  var logout = function () {
    window.location.assign("/users/fully_log_out");
  };

  var isAdmin = function () {
    return ($rootScope.trueUser || {}).admin || ($rootScope.user || {}).admin;
  };

  var acceptRetailerTermsAndConditions = function () {
    $http({
      method: "PUT",
      url: "/api/retailer/users/" + $rootScope.user.id,
      params: {
        user: {
          accepted_terms: true,
        },
      },
    }).then(function success(res) {
      $rootScope.user.accepted_terms_at = true;
    });
  };

  var acceptDistributorTermsAndConditions = function () {
    $http({
      method: "PUT",
      url: "/api/distributor/user/",
      data: {
        user: {
          accepted_terms: true,
        },
      },
    }).then(function success(res) {
      $rootScope.user.accepted_terms_at = true;
    });
  };

  return {
    userNameString: userNameString,
    load: load,
    loadOnboarding: loadOnboarding,
    logout: logout,
    trueUser: trueUser,
    isAdmin: isAdmin,
    acceptRetailerTermsAndConditions: acceptRetailerTermsAndConditions,
    acceptDistributorTermsAndConditions: acceptDistributorTermsAndConditions,
  };
};

service.$inject = ["$rootScope", "$http", "CachedRequest", "$q", "C"];

tiz.service("User", service);

export { userNameStringUtil };
